<script>

    import { replace } from 'svelte-spa-router'
    import { toast } from 'bulma-toast'

    import UsersService from '../$services/users.service'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputPassword from '../$components/input.password.svelte'
    import Button from '../$components/button.svelte'

    let data = {}
    let loading = false

    async function onLogin() {
        loading = true
        const resp = await UsersService.userLogin(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        const user = resp.data.user
        const roles = ['admin', 'adviser', 'support', 'seller']

        if(roles.indexOf(user.role) === -1)
            return toast({message: 'Usuario no autorizado', type: 'is-danger'})

        switch(user.role) {
            case 'admin': replace('#/graphics'); break
            case 'support': replace('#/shipments'); break
            case 'adviser': replace('#/users'); break
            case 'seller': replace('#/clients'); break
            default: replace('#/shipments')
        }
    }

</script>

<style>
    .heading {
        font-size: 26px;
        font-weight: 800;
        color: #1a1a1a;
        margin: 0 0 4px;
    }

    .subheading {
        font-size: 14px;
        color: #888;
        margin: 0 0 32px;
    }

    .login-submit {
        margin-top: 0.5rem;
    }
</style>

<h1 class="heading">Bienvenido de vuelta</h1>
<p class="subheading">Ingresa tus datos para continuar</p>

<Form on:submit={onLogin} { loading }>
    <InputText
        bind:value={data.email}
        label="Correo electrónico"
        inputType="email"
        placeholder="tucorreo@ejemplo.com"
    />
    <InputPassword
        bind:value={data.password}
        label="Contraseña"
        placeholder="••••••••"
    />
    <div class="login-submit">
        <Button type="submit" text="Entrar al sistema" color="primary" fullwidth { loading } />
    </div>
</Form>
